import React, { Fragment } from "react";
import { Checkbox, FormControlLabel, RadioGroup } from "@mui/material";
import { formatDatetime } from "@_utils/helpers";
import { invoiceTemplateConstants } from "@_constants/invoiceTemplate.constants";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";
import InfoPopup from "@_components/popups/InfoPopup/InfoPopup";

/**
 * Presentational invoice-attachment UI: the "no invoices" info popup and the
 * "choose invoices" popup with its radio list. All state and the
 * download/selection handlers are owned by MailPopup; this is a pure move
 * of the markup (including the former generateInvoiceList render helper).
 */
function InvoicePicker({
  invoiceActivities,
  noInvoicesPopupOpen,
  onCloseNoInvoices,
  caseIdLabel,
  chooseInvoicePopupOpen,
  onCloseChooseInvoice,
  onConfirmChooseInvoice,
  handleInvoiceCheckboxChange,
}) {
  const invoiceList = (
    <RadioGroup name="InvoiceRadioGroup">
      {" "}
      <table cellSpacing={10}>
        <tbody>
          {invoiceActivities.map((activity) => (
            <Fragment key={activity.id}>
              <tr>
                <td>
                  <FormControlLabel
                    value={activity.content.invoice_id}
                    control={
                      <Checkbox
                        defaultChecked={invoiceActivities.length === 1}
                      />
                    }
                    onChange={(e, index) =>
                      handleInvoiceCheckboxChange(e, index)
                    }
                    label={activity.content.invoice_number}
                  />
                </td>
                <td>
                  {activity.content.type ===
                  invoiceTemplateConstants.INVOICE_TYPE_ACTIVE
                    ? "Invoice"
                    : activity.content.type ===
                        invoiceTemplateConstants.INVOICE_TYPE_CANCELLATION
                      ? "Cancellation Invoice"
                      : activity.content.type ===
                          invoiceTemplateConstants.INVOICE_TYPE_CANCELLED
                        ? "Invoice (Cancelled)"
                        : "Unknown Type"}
                </td>
                <td>{formatDatetime(activity.created, "medium")}</td>
              </tr>
            </Fragment>
          ))}
        </tbody>
      </table>
    </RadioGroup>
  );

  return (
    <>
      <InfoPopup
        open={noInvoicesPopupOpen}
        close={onCloseNoInvoices}
        title={"Information"}
        onClick={onCloseNoInvoices}
        confirmBtn="Ok"
        show
      >
        <div>
          No invoices found for case {caseIdLabel}.
          <br />
          <br />
          You need to create an invoice first before you can add it as an
          attachment.
        </div>
      </InfoPopup>
      <AreYouSurePopup
        open={chooseInvoicePopupOpen}
        close={onCloseChooseInvoice}
        title={"Choose Invoices to attach"}
        onClick={onConfirmChooseInvoice}
        confirmBtn="Ok"
        cancelBtn="Cancel"
      >
        {invoiceList}
      </AreYouSurePopup>
    </>
  );
}

export default InvoicePicker;
